export const BLUE = "#3978ff";
export const RED = "#fb1f43";
export const ORANGE = "#ffa200";
export const VIOLET = "#db54ff";

export const colors = [VIOLET, RED, ORANGE, BLUE];
